<template>
  <div class="mypooq-inner-wrap">
    <section>
      <div class="mypooq-info-body">
        <like-list viewMode="movie"/>
      </div>
    </section>
  </div>
</template>

<script>
import LikeList from '@/components/mypooq/LikeList'
import { titleTagNameChange } from '@/common/utils/common'
export default {
  components: {
    LikeList
  },
  created () {
    titleTagNameChange('관심 영화 : 웨이브 MY')
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/my.scss"></style>
